import { render } from "./DesignBrandingView.vue?vue&type=template&id=1ebebff7&scoped=true"
import script from "./DesignBrandingView.vue?vue&type=script&lang=js"
export * from "./DesignBrandingView.vue?vue&type=script&lang=js"

import "./DesignBrandingView.vue?vue&type=style&index=0&id=1ebebff7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ebebff7"]])

export default __exports__